<div style="padding: 30px; overflow: scroll">
  <mat-dialog-content> </mat-dialog-content>
  <mat-dialog-actions> </mat-dialog-actions>
</div>
